/// <reference path="../../@types/index.d.ts" />
import { VelocityComponent, VelocityTransitionGroup } from "velocity-react";
export var Animate = VelocityComponent;
export var AnimateTransitionGroup = VelocityTransitionGroup;
//# sourceMappingURL=Animate.js.map